export default "__VITE_ASSET__DNKUqRxJ__"